<template>
  <div class="testimonials testimonials--large">
    <h3 class="testimonials__header testimonials__header--large">{{formattedHeaderText}}</h3>
    <div class="testimonials__avatars">
      <img
        class="testimonials__avatar"
        @click="setCurrentSelectedId(review.id)"
        v-for="review in highlights"
        :src="review.image"
        :key="review.id"
        :class="getAvatarState(review.id)">
    </div>
    <ul class="testimonials__list testimonials__list--full">
      <li
      class="testimonials__testimonial"
      :class="getTestimonialState(review.id)"
      v-for="(review) in highlights"
      :key="review.name">
      <p class="testimonials__index">0{{review.id}}</p>
        <span class="testimonials__name testimonials__name--large">
          <strong>{{review.name}}</strong>
        </span>
        <span class="testimonials__review">
          {{review.review}}
        </span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import {
  Component,
  Prop,
  Provide,
  Vue,
  Watch
} from 'vue-property-decorator';
import Review from '../../models/Review';
import { tokenService } from '../../services/TokenService';

@Component
export default class HighlightsComponent extends Vue {
  @Prop({ default: 'Gran Coupé - Highlights' })
  public headerText!: string;

  @Prop({
    default: () => [new Review(
      1,
      'Sporty Looks',
      'The BMW 2 Series Gran Coupé boasts an elegant silhouette, which is complemented by confident design features such as the Icon design LED lights and frameless doors.',
      5,
      `${process.env.BASE_URL}images/kmi/bmw-2-series-rear.png`
    ),
    new Review(
      2,
      'Modern Ambience',
      'The driver-oriented cockpit interior, which also features dramatic illuminated accent trims gives the journey a modern yet premium atmosphere.',
      5,
      `${process.env.BASE_URL}images/kmi/bmw-2-series-interior.png`
    ),
    new Review(
      3,
      'Unrivalled Handling',
      'With the combination of either front wheel drive or xDrive four-wheel drive, the BMW 2 Series Gran Coupé offers stunning levels of control.',
      4,
      `${process.env.BASE_URL}images/kmi/bmw-2-series-front.png`
    )]
  })
  public highlights!: Review[];

  public get formattedHeaderText() {
    return tokenService.replaceToken(this.headerText);
  }

  private selectedTestimonalId: number = 1;

  get currentTestimonial(): Review {
    return this.highlights.filter((x) => x.id === this.selectedTestimonalId)[0];
  }

  public getTestimonialState(id: number): string {
    return this.currentTestimonial.id !== id
      ? 'testimonials__testimonial--hidden'
      : '';
  }

  public getAvatarState(id: number): string {
    return this.selectedTestimonalId !== id
      ? ''
      : 'testimonials__avatar--active';
  }

  public setCurrentSelectedId(id: number) {
    this.selectedTestimonalId = id;
  }
}
</script>
